import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { EncuestaService } from '../services/encuesta.service';
import { Poll } from '../models/encuesta';

@Component({
    selector: 'app-report-encuesta',
    templateUrl: './reportEncuesta.component.html',
    styleUrls: ['./reportEncuesta.component.css'],
    providers: [EncuestaService]
})

export class ReportEncuestaComponent implements OnInit {
    public cols: any[];
    public listreportAgenda: Poll[] = [];
    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _encuestaService: EncuestaService
    ) {
        this.cols = [
            { field: 'date', header: 'Fecha' },
            { field: 'objective', header: 'Se Cumplio el Objetivo' },
            { field: 'objectiveText', header: 'Texto Objetivo' },
            { field: 'facility', header: 'Facilidad' },
            { field: 'personnel', header: 'Personal' },
            { field: 'experience', header: 'Experiencia' },
            { field: 'recommend', header: 'Lo Recomendaria' },
        ];
    }
    ngOnInit() {
        this.getAgenda();
    }
    getAgenda() {
        
        this._encuestaService.get().subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listreportAgenda = response.object;
                    console.log(this.listreportAgenda);
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = date.getMonth() +1;
        const day = date.getDate();
        if(month <=9 && day <=9) {
            return year + '0' + month + '0' + day;  
        } else if(month <=9 && day >9){
            return year  + '0' + month  + day;
        }  else if(month >9 && day <=9){
            return year   + month  + '0'  + day;
        } else {
            return year + '-'  + month + '-' + day;
        }
        
    }
}